/**
 * Shared class recipes for plain form controls (inputs, selects,
 * textareas), kept out of any component file so react-refresh still sees
 * component-only exports — same reasoning as chipVariants.ts.
 */
export const inputClass =
  'cr-w-full cr-rounded-md cr-border cr-border-blue-900 cr-bg-white cr-px-2 cr-py-1 cr-text-blue-900 ' +
  'focus:cr-outline-2 focus:cr-outline-cirrusBlue-400';

export const selectClass =
  'cr-rounded-md cr-border cr-border-blue-900 cr-bg-white cr-px-2 cr-py-1 cr-text-blue-900';
